import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MainFooter',
  props: ['textPages'],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props
const copyrihgth = window.COPYRIGHT


const __returned__ = { props, copyrihgth, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})